import React from "react";
import {VisibilityContext} from "react-horizontal-scrolling-menu";
import {BiChevronRight, BiChevronLeft} from 'react-icons/bi';

// from
// https://codesandbox.io/s/react-horizontal-scrolling-menu-v2-dynamically-add-it
// ems-38ted?file=/src/arrows.tsx:0-1843
function Arrow({children, disabled, onClick}) {
    return (
        <button
            disabled={disabled}
            onClick={onClick}
            className={(disabled ? 'hidden ' : 'block ') +
                `cursor-pointer justify-center flex flex-row items-center select-none btn-circle w-12 h-12 rounded-full bg-neutral border-none shadow p-0`}>
            {children}
        </button>
    );
}

export function LeftArrow() {
    const {isFirstItemVisible, scrollPrev, visibleItemsWithoutSeparators, initComplete} = React.useContext(VisibilityContext);

    const [disabled, setDisabled] = React.useState(!initComplete || (initComplete && isFirstItemVisible));
    
    React.useEffect(() => {
        // NOTE: detect if whole component visible
        if (visibleItemsWithoutSeparators.length) {
            setDisabled(isFirstItemVisible);
        }
    }, [isFirstItemVisible, visibleItemsWithoutSeparators]);

    return (
        <Arrow disabled={disabled} onClick={() => scrollPrev()}>
            <BiChevronLeft size="24px" />
        </Arrow>
    );
}

export function RightArrow({pageToken, pushNewItems, numOfItems}) {
    const {isLastItemVisible, scrollNext, visibleItemsWithoutSeparators} = React.useContext(VisibilityContext);
    const [disabled, setDisabled] = React.useState(!visibleItemsWithoutSeparators.length && isLastItemVisible);
    
    React.useLayoutEffect(() => {
        // use ajax to get new items
        if (isLastItemVisible) {
            pushNewItems();
        }
        // no more items, don't show right arrow
        if (pageToken == null) {
            setDisabled(isLastItemVisible);
        }
        if (visibleItemsWithoutSeparators.length) {
            setDisabled(isLastItemVisible);
        }
    }, [pageToken, isLastItemVisible, visibleItemsWithoutSeparators]);

    return (
        <Arrow disabled={disabled} onClick={() => scrollNext()}>
            <BiChevronRight size="24px" />
        </Arrow>
    );
}
